module.exports = __webpack_public_path__ + "static/media/card_discover.0eb3fd78.svg";